var _polygon, _path, _circle, _path2, _circle2, _path3, _rect, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrTypeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.1028,
    y1: 14.6843,
    x2: 32.8918,
    y2: 40.4734
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2214,
    style: {
      stopColor: "#F8F8F8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5415,
    style: {
      stopColor: "#E5E5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    style: {
      stopColor: "#C6C6C6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BEBEBE"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_1_)",
    points: "1.1,34.5 12.6,14.7 15.5,19.7 9.9,29.5 30.1,29.5 17.1,6.8 20,1.8 38.9,34.5  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#464646",
    d: "M20,2.8L38,34H2l10.6-18.3l2.3,4L9,30h22L17.7,6.8L20,2.8 M20,0.8l-0.9,1.5l-2.3,4l-0.3,0.5l0.3,0.5 L29.3,29H10.7l5.1-8.8l0.3-0.5l-0.3-0.5l-2.3-4l-0.9-1.5l-0.9,1.5L1.1,33.5L0.3,35H2h36h1.7l-0.9-1.5l-18-31.2L20,0.8L20,0.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.1612,
    y1: 26.1612,
    x2: 43.8388,
    y2: 43.8388
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#73B4C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1747,
    style: {
      stopColor: "#6AAEC3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4567,
    style: {
      stopColor: "#529EB5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8089,
    style: {
      stopColor: "#2C839F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#147391"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_2_)",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 35,
    cy: 35,
    r: 12.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    d: "M42.5,33"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 35,
    cy: 42,
    r: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#147391",
    d: "M35,40.5c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5s-1.5-0.7-1.5-1.5S34.2,40.5,35,40.5 M35,39.5 c-1.4,0-2.5,1.1-2.5,2.5s1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5S36.4,39.5,35,39.5L35,39.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33.5,
    y: 26.5,
    fill: "#FFFFFF",
    width: 3,
    height: 12
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#147391",
    d: "M36,27v11h-2V27H36 M37,26h-1h-2h-1v1v11v1h1h2h1v-1V27V26L37,26z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrTypeIcon);
export default __webpack_public_path__ + "static/media/pr-type-icon.13c4a579f8d5b6b34273c63d12ac0a53.svg";
export { ForwardRef as ReactComponent };